<nav class="top-nav">
  <a [routerLink]="URLS.root"
     class="brand">
    <img [src]="BRAND.logo.main" [alt]="BRAND.name" class="brand-logo" height="48" width="48"/>
  </a>
  <div class="left-item-wrapper">
    <!-- owner 2026-10-11: Apps & Plugins first, then Themes, Tools, Palettes, Blog (Customers removed 2026-10-12) -->
    <a [routerLink]="URLS.plugins.plugins">
      <span>Apps &amp; Plugins</span>
    </a>
    <a [routerLink]="URLS.themes">
      <span>Themes</span>
    </a>
    <a [routerLink]="URLS.tools.tools">
      <span>Tools</span>
    </a>
    <a [routerLink]="URLS.palettes">
      <span>Palettes</span>
    </a>
    <a [routerLink]="URLS.blog">
      <span>Blog</span>
    </a>
  </div>
  <div class="right-item-wrapper">
    <!-- Cart: the bag with the item count and the word, on every page; click drops the mini cart down. -->
    <app-mini-cart></app-mini-cart>
    <a role="button"
       (mouseenter)="dropdownMenuTheme.hoverOpen()"
       (mouseleave)="dropdownMenuTheme.scheduleClose()"
       (click)="dropdownMenuTheme.toggle($event)"
       [class.menu-open]="dropdownMenuTheme.isDropdownOpen">
      <app-dropdown-menu #dropdownMenuTheme
                         [sections]="settingsSections"
                         [minimumColumns]="1"
                         [alignRight]="true"
                         [macPopover]="true"
                         [closeOnSelect]="false"
                         (itemSelect)="onSettingSelect($event)">
        <span class="appearance-trigger">
          <img *ngIf="currentProductLogo" [src]="currentProductLogo" alt="" class="appearance-icon appearance-theme-logo"/>
          <span *ngIf="!currentProductLogo" class="appearance-icon appearance-mode-icon"
                [ngClass]="'appearance-mode-icon--' + currentModeVariant" aria-hidden="true"></span>
          Appearance
        </span>
      </app-dropdown-menu>
    </a>
    <app-contact-popover></app-contact-popover>
  </div>
</nav>
<div [class.landing-layout-top-nav-loading-bar]="loading"></div>
